module.exports = __webpack_public_path__ + "img/banner1.820f65c9.png";